import "./App.css";
import { Switch, Route } from "react-router-dom";
import Home from "./components/Home/home";
import ContactUs from "./components/Us/contact_us";
import Products from "./components/Home/products";
import Product from "./components/Home/product";
import Header from "./components/Header/header";
import Footer from "./components/Footer/footer";
import Jobs from "./components/Home/job_board";
import AboutUs from "./components/Home/aboutUs";
import Container from "react-bootstrap/Container";
import NotFound from "./components/Expcetion/not_found";
const App = () => {
  return (
    <Container>
      <Header />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/products" component={Products} />
        <Route path="/products/:id" component={Product} />
        <Route path="/jobs" component={Jobs} />
        <Route path="/about-us" component={AboutUs} />
        <Route path="/contact-us" component={ContactUs} />
        <Route component={NotFound} />
      </Switch>
      <Footer />
    </Container>
  );
};

export default App;
